import { ModalPopup, Tooltip } from "client/CommonComponents";
import moment from "moment";
import Delete from "../../../../assets/images/Delete.svg";
import "./MyAlert.scss";
import { DATE_FORMAT } from "client/utils/constants";
import LoadingWrapper from "../../../../CommonComponents/LoadingWrapper"

interface IProps {
  myAlertDetails?: any;
  onDeleteConfirm?: any;
  setDeletePopup?: any;
  deletePopup?: any;
  clearAllAlert?: any;
  deleteAllAlerts?: any;
  setDeleteAllAlert?: any;
  onDeleteAllConfirmation?: any
  isLoading: boolean
}
const MyAlert = ({
  myAlertDetails,
  onDeleteConfirm,
  deletePopup,
  setDeletePopup,
  clearAllAlert,
  deleteAllAlerts,
  setDeleteAllAlert,
  onDeleteAllConfirmation,
  isLoading
}: IProps) => {
  return (
    <>
      <div className="my-alert-block">
        <div className="mb-1 top-section">
          <p className="heading">
            MY ALERTS{" "}
            {myAlertDetails?.alertCount
              ? `(${myAlertDetails?.alertCount})`
              : ""}
          </p>
          <a href='/' className={myAlertDetails?.alertCount > 0 ? "clear-all" : "disable-Clear-all clear-all"}  onClick={(e: any) => clearAllAlert(e)}>Delete All</a>
        </div>
        <LoadingWrapper isLoading={isLoading} data-attribute="MyAlert_Default_LoadingWrapper">      
        {myAlertDetails?.alertDetails?.length > 0 ? (
          <div className="card-block">
            {myAlertDetails?.alertDetails?.map((item: any, index: any) => {
              const getText = ((html: any) => {
                let divContainer = document.createElement("div");
                divContainer.innerHTML = html;
                let text = (divContainer?.childNodes[0]?.childNodes[0]?.childNodes[0]?.textContent + ", " + divContainer?.childNodes[0]?.childNodes[0]?.childNodes[1]?.textContent + ", " + divContainer?.childNodes[0]?.childNodes[1]?.textContent + ", " + divContainer?.childNodes[0]?.childNodes[2]?.textContent);
                return text || "";
              })
              return (
                <div className="card-details" key={index}>
                  <div className="order-icon-section">
                    <div className={item.icontype}>
                      <img src={item.iconBlobUrl} alt="" />
                    </div>
                  </div>
                  <div className = "notificationClass">
                  <Tooltip content= {getText(item?.notificationMessage)}  data-attribute="MyAlert_Default_Tooltip">
                  <div
                    className={`order-detail-section click-alert-${index}`}
                    dangerouslySetInnerHTML={{
                      __html: item.notificationMessage,
                    }}
                  > 
                    </div>
                 </Tooltip>
                 </div>
                  <div className="order-date-section">
                    {item?.isReminder ? moment(new Date(item.reminderDate)).format(DATE_FORMAT) : moment(new Date(item.created)).format(DATE_FORMAT)}
                    <div
                      className="edit-delete-section"
                      onClick={() => setDeletePopup(item.sentNotificationId)}
                    >
                      <img
                        src={Delete}
                        alt=""
                        className="delete-icon fa-pencil"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="no-record-data">No Alert Available</div>
        )}
        </LoadingWrapper>
      </div>
      {deletePopup && (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle="Delete Alert"
          ModalPopupType="small"
          FooterSecondaryBtnTxt="cancel"
          FooterPrimaryBtnTxt="Delete"
          closeModalPopup={() => setDeletePopup(false)}
          PrimaryBtnOnclick={onDeleteConfirm}
          SecondryBtnOnclick={() => setDeletePopup(false)}
          ModalPopupName = "DeletePopUp-Alert"
         data-attribute="MyAlert_Default_ModalPopup">
          <p className="text-Delete">Are you sure you want to delete this alert ?</p>
        </ModalPopup>
      )}
      {deleteAllAlerts && (
        <ModalPopup
          ShowModalPopupFooter={true}
          ModalPopupTitle="Delete All Alerts"
          ModalPopupType="small"
          FooterSecondaryBtnTxt="cancel"
          FooterPrimaryBtnTxt="Delete"
          closeModalPopup={() => setDeleteAllAlert(false)}
          PrimaryBtnOnclick={onDeleteAllConfirmation}
          SecondryBtnOnclick={() => setDeleteAllAlert(false)}
          ModalPopupName = "DeletePopUp-Alert"
         data-attribute="MyAlert_Default_ModalPopup_2">
          <p className="text-Delete">Are you sure you want to delete all the alerts ?</p>
        </ModalPopup>
      )}
    </>
  );
};

export default MyAlert;
